var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-list-content"},[_c('HeadListNav',{attrs:{"nav":_vm.sonNav}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }